import { Flex, Text } from '@modusign/design-system';

import Badge from '@app/features/authorization/components/Badge';

function BatchPermissionGrantModalSubHeader({
  count,
  children,
}: {
  count: number;
  children?: React.ReactNode;
}) {
  return (
    <Flex alignItems="center" justifyContent="space-between" width="100%">
      <Text fontWeight="medium" py={3}>
        <Text color="textEmphasisBase" fontWeight="medium">
          ‘열람 가능’
        </Text>
        으로 공유할 멤버·그룹
        <Badge sx={{ ml: 2 }} variant="emphasis">
          {count}
        </Badge>
      </Text>
      {children}
    </Flex>
  );
}

export default BatchPermissionGrantModalSubHeader;
